import RestService from './RestService'
import http from "superagent";

export default class AppService extends RestService {
    constructor() {
        super('apps')
    }

    listWebsites() {
        let url = this.baseUrl + '/api/v1/sites.json?t=' + Date.now()
        return this.executeGet(url)
    }

    addBlog(appId) {
        let url = this.baseUrl + `/api/v1/add-blog/${appId}.json?t=${Date.now()}`
        return this.executeGet(url)
    }

    addEmailList(appId) {
        let url = this.baseUrl + `/api/v1/email-list/${appId}.json?t=${Date.now()}`
        return this.executeGet(url)
    }

    // GET 'apps/:id/copy-template/:template_id'
    copyModels(appId, appTemplateId) {
        let url = this.baseUrl + '/api/v1/apps/' + appId + '/copy-template/' + appTemplateId + '.json?t=' + Date.now()
        return new Promise((resolve, reject) => {
            this.http.get(url)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }

    initApp(appId) {
        console.log('***** calling init app ***** ... app id: ' + appId)
        let url = this.baseUrl + '/api/v1/apps/' + appId + '.json?t=' + Date.now()
        return new Promise((resolve, reject) => {
            http.get(url)
                .set('x-api-token', this.authToken)
                .end((error, response) => {

                    if (response.status === 200) {
                        const app = JSON.parse(response.text)
                        webase.utils.app.initAppProperties(app)
                        resolve(app)
                    } else {
                        console.log('Get Error')
                        console.log(error)
                        reject(response.statusText)
                    }
                })
        });
    }

    inviteUserToCollaborate(email, appId, site) {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '/' + appId + '/create-invite'
        return new Promise((resolve, reject) => {
            let data = {invite: {email: email, app_id: appId, site: site}}
            this.http.post(url)
                .send(data)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }
}